import { render } from "./B2bTwoFactorAuthFormGeneric.vue?vue&type=template&id=cc9cf9f4&scoped=true&lang=pug"
import script from "./B2bTwoFactorAuthFormGeneric.vue?vue&type=script&lang=js"
export * from "./B2bTwoFactorAuthFormGeneric.vue?vue&type=script&lang=js"

import "./B2bTwoFactorAuthFormGeneric.vue?vue&type=style&index=0&id=cc9cf9f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc9cf9f4"]])

export default __exports__